import { ref } from 'vue'

const searchRef = ref('')
export function useLocationData() {
	const search = searchRef

	return {
		search,
	}
}
